module.exports = __webpack_public_path__ + "static/media/about_1.490cf141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_1.jpg
// module id = 282
// module chunks = 0